import axios from "axios";
import React, { useEffect, useState } from "react";
import ProductsInViewLead from "../components/lead_and_quotation/ProductsInViewLead";

import { format } from "date-fns";

const ViewLead = ({
  onClose,
  selectedLead,
  onEditLeadFromViewLead,
  clickedOnEditLead,
}) => {
  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  //console.log("selectedLead:in view Lead", selectedLead);

  const [selectedLeadSingle, setSelectedLeadSingle] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]);
  const [productEntries, setProductEntries] = useState([]);
  const [productsInQuotationState, setProductsInQuotation] = useState(null);
  const [currentProductEntryRowId, setCurrentProductEntryRowId] =
    useState(null);
  const [productData, setProductData] = useState([]);
  const [currentProductTyping, setCurrentProductTyping] = useState(null);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [duplicateItemCodeSnackbar, setDuplicateItemCodeSnackbar] =
    useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  let userDepartment = localStorage.getItem("currentSelectedDepartment");

  console.log("userDepartment", userDepartment);

  useEffect(() => {
    if (selectedLeadSingle && selectedLeadSingle.Cnt > 0) {
      const leadId = selectedLeadSingle.lead_id;
      const masterCountApiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/LEADITEMS/${leadId}/${userDepartment}`;

      console.log("Fetching lead items from:", masterCountApiUrl);

      axios
        .get(masterCountApiUrl)
        .then((response) => {
          console.log("Lead Items Data:", response.data);

          let productListFromAlreadySendQuotation = response.data.map(
            (item, index) => {
              return {
                id: new Date().getTime() + index,
                isSelectedItemCodeCorrect: true,
                itemCode: item.Prod_code,
                itemDescription: item.Prod_Description,
                itemUnit: item.Prod_Unit,
                itemQuantity: item.Prod_Qty,
                itemPrice: item.Prod_Price,
                itemAmount: item.Prod_Qty * item.Prod_Price,
                itemCurrentStock: "",
                itemImage: item.prod_imagepath,
                area_code: "",
                quotation_number: "",
                revision_number: "",
                foot1: "",
              };
            },
          );

          setProductsInQuotation(productListFromAlreadySendQuotation);
        })
        .catch((error) => {
          console.error("Error fetching lead items:", error);
        });
    }
  }, [selectedLeadSingle]);

  useEffect(() => {
    let textToSearch = "-";

    let currentUserEMPID = "-";

    const currentUserfromLocalStorage = JSON.parse(
      localStorage.getItem("currentUser"),
    );

    if (currentUserfromLocalStorage) {
      console.log(
        "currentUserfromLocalStorage[0] ",
        currentUserfromLocalStorage[0],
      );
      currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
    } else {
      console.log(
        "currentUserfromLocalStorage[0] else",
        currentUserfromLocalStorage[0],
      );
    }

    const todayDate = format(new Date(), "yyyy-MM-dd");
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));

    console.log("currentUserObject", currentUserObject);

    const userFromUserObjectInLocalStorage = currentUserObject[0].user?.trim();

    const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

    const userAccessGroup = currentUserObject[0].accessgrp;

    const filterObjectFromModal = {
      fromDate: "1900-01-01",
      toDate: todayDate,
      task_coordinator:
        userAccessGroup?.trim().toUpperCase() === "COORDINATOR"
          ? empIDFromUserObjectInLocalStorage
          : "-",
      task_salesperson:
        userAccessGroup?.trim().toUpperCase() != "COORDINATOR" &&
        userAccessGroup?.trim().toUpperCase() != "ADMIN" &&
        userAccessGroup?.trim().toUpperCase() != "CADMIN"
          ? empIDFromUserObjectInLocalStorage
          : "-",
      task_creator_id: "-",
      lead_status: "-",
    };


    

    let idOfSalesPersonToPassInAPI = currentUserEMPID ; // filterObjectFromModal.task_salesperson earlier 

    let idOfCoordinatorToPassInAPI = currentUserEMPID ;

    let idOfCreatorViewToPassInAPI = currentUserEMPID ;

    const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
      ? JSON.parse(localStorage.getItem("currentUser"))
      : "";

    const USER_ACCESS = CURRENT_USER_OBJECT[0]?.useraccess;
    if (USER_ACCESS.indexOf("ZK") !== -1) {
      console.log("String is present, that means salesperson view");
      // just pass sales person because OO is present
    } else {
      idOfSalesPersonToPassInAPI = "-";
    }

    if (USER_ACCESS.indexOf("ZL") !== -1) {
      console.log("String is present, that means cordinator view");
      // just pass sales person because OO is present
    } else {
      idOfCoordinatorToPassInAPI = "-";
    }

    if (USER_ACCESS.indexOf("ZM") !== -1) {
      console.log("String is present, that means creator view");
      // just pass sales person because OO is present
    } else {
      idOfCreatorViewToPassInAPI = "-";
    }

    //const apiurl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMLeadMainList/${company_code_from_local_storage}/Single/-/-/-/${selectedLead.lead_id}/${userDepartment}/${filterObjectFromModal.fromDate}/${filterObjectFromModal.toDate}/${textToSearch}/${filterObjectFromModal.lead_status}/-?task_coordinator=${filterObjectFromModal.task_coordinator}&task_salesperson=${filterObjectFromModal.task_salesperson}&task_creator_id=${currentUserEMPID}`;

    // pass - if admin or other users in lead_creatorid but if selfview is enabled in rights pass -

    const apiurl =  `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMLeadMainList/${company_code_from_local_storage}/Single/${idOfCoordinatorToPassInAPI}/${idOfSalesPersonToPassInAPI}/${idOfCreatorViewToPassInAPI}/${selectedLead.lead_id}/${userDepartment}/1900-01-01/${todayDate}/${textToSearch}/-/-`

    axios
      .get(apiurl)
      .then((res) => {
        setSelectedLeadSingle(res.data[0]);
        // console.log("res.data:", res.data);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  }, []);

  const handleAddRow = (e) => {
    e.preventDefault();

    console.log("handle add row clicked in viewlead");

    if (productsInQuotationState) {
      const newRow = {
        id: Date.now(),
        itemCode: "",
        itemDescription: "",
        itemImage: "",
        itemUnit: "",
        itemCurrentStock: "",
        itemQuantity: "",
        itemPrice: "",
        itemAmount: "",
        isSelectedItemCodeCorrect: false,
      };

      setProductsInQuotation((prevEntries) => [...prevEntries, newRow]);
    } else {
      const newRow = {
        id: Date.now(),
        itemCode: "",
        itemDescription: "",
        itemImage: "",
        itemUnit: "",
        itemCurrentStock: "",
        itemQuantity: "",
        itemPrice: "",
        itemAmount: "",
        isSelectedItemCodeCorrect: false,
      };

      setProductsInQuotation([newRow]);
    }
  };

  const clearProductsList = () => {};

  const handleDeleteSelected = () => {};
  const handleInputChange = (id, field, value) => {
    setCurrentProductEntryRowId(id);

    console.log(
      "handleInputChange row id productsInQuotationState",
      id,
      field,
      productsInQuotationState,
    );

    // Set the current value being typed
    setCurrentProductTyping(value);
    if (field === "itemCode") {
      console.log("itemcode is set");
      fetchItemDetails(value, id); // Call your fetch function for item details
    }

    // Update the productEntries state with the new value
    let newArray = productsInQuotationState?.map((item) => {
      if (item.Lead_ID) {
        if (item.Prod_code === id) {
          console.log("item.Prod_code === id", item.Prod_code, id);

          return {
            ...item,
            [field]: value,
            ...(field === "itemCode" && { isSelectedItemCodeCorrect: false }), // Set isSelectedItemCodeCorrect to false when itemCode changes
          };
        }
        return item;
      } else {
        if (item.id === id) {
          return {
            ...item,
            [field]: value,
            ...(field === "itemCode" && { isSelectedItemCodeCorrect: false }), // Set isSelectedItemCodeCorrect to false when itemCode changes
          };
        }
        return item;
      }
    });

    // Set the updated productEntries array to state
    setProductsInQuotation(newArray);
  };

  const fetchItemDetails = async (itemCode, rowId) => {
    console.log(`Fetching details for Item Code: ${itemCode}`); // Log item code before fetching
    if (!itemCode) return;

    setTimeout(async () => {
      try {
        const response = await fetch(
          `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/Sitem/${itemCode}`,
        );

        console.log("API response status:", response.status); // Log API response status

        const data = await response.json();
        console.log("API response data:", data); // Log response data
        setProductData(data);
      } catch (error) {
        console.error("Error fetching item details:", error);
      }
    }, 500); // Delay API call to avoid excessive requests
  };

  const selectProduct = (setProductCode) => {
    console.log("index of select product", setProductCode);
    setIsSubmittingForm(true);

    const isDuplicate = productEntries.some(
      (product) => product.itemCode === setProductCode,
    );
    if (isDuplicate) {
      // alert('this item already exists')
      setDuplicateItemCodeSnackbar(true);
      setIsSubmittingForm(false);
      return;
    }

    const selectedProduct = productData.find(
      (product) => product.Code === setProductCode,
    );

    if (selectedProduct) {
      setProductsInQuotation((prevEntries) =>
        prevEntries.map((entry) =>
          entry.id === currentProductEntryRowId
            ? {
                ...entry,
                itemCode: selectedProduct.Code,
                itemDescription: selectedProduct.Description,
                itemImage: selectedProduct.Imagepath,
                // itemUnit: selectedProduct.unit,
                itemUnit: "PCS",
                itemCurrentStock: selectedProduct.Stick, // Adjust according to your product data
                itemPrice: selectedProduct.SelPrice, // Adjust according to your product data
                itemAmount: selectedProduct.SelPrice * entry.itemQuantity, // Example calculation
                isSelectedItemCodeCorrect: true, // Example calculation
              }
            : entry,
        ),
      );
    }
    setIsDropdownOpen(false);
    setProductData(null);
  };

  const productEntryInAllEntries = () => {};

  const splitText = (stringReceived) => {
    console.log("stringReceived ", stringReceived);

    let n = 10; // insert a character after every 5 characters
    let insertChar = "\n";
    let outputString = stringReceived.split(",");

    return outputString;
  };

  const arrangeSalesPersonNameArray = (arrayToBeOrdered) => {
    console.log("arrayToBeOrdered ", arrayToBeOrdered);

    let newArray = arrayToBeOrdered.map((textToBeEdited) => {
      if (textToBeEdited.includes("@")) {
        return "Email : " + textToBeEdited;
      } else if (!isNaN(textToBeEdited.replace(/\s/g, ""))) {
        return "Mob : " + textToBeEdited;
      } else {
        return textToBeEdited;
      }
    });

    let mobObject = newArray.filter((itemFilter) => {
      return itemFilter.includes("Mob");
    });

    let emailObject = newArray.filter((itemFilter) => {
      return itemFilter.includes("@");
    });

    let nameObject = newArray.filter((itemFilter) => {
      return !itemFilter.includes("@") && !itemFilter.includes("Mob");
    });

    console.log(
      "arrayToBeOrdered newArray mobObject--",
      newArray,
      mobObject,
      emailObject,
    );

    return [newArray];
  };

  return (
    <div className="z-50 fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center lg:w-full  ">
      <div className="bg-white p-6 rounded-lg shadow-xl min-w-[95vw] max-w-lg max-h-[80vh] overflow-y-auto scrollbar-hide">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-3">
          <div style={{ display: "flex", alignItems: "center" }}>
            <h2 className="text-2xl font-normal text-gray-800 ">
              Lead Details
            </h2>
            <div className="mt-2 text-center">
              <button
                // onClick={() => onEditLeadFromViewLead(selectedLead, productsInQuotationState)}
                onClick={() =>
                  clickedOnEditLead(
                    selectedLeadSingle,
                    productsInQuotationState,
                  )
                }
                className="ms-4 px-5 py-2.5 bg-gradient-to-r from-gray-700 to-gray-900 text-white rounded-lg shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 ease-in-out"
              >
                Edit Lead
              </button>
            </div>
          </div>

          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
            title="Close"
          >
            ✖
          </button>
        </div>

        {/* Lead Details */}
        <div className="mt-4 lg:grid lg:grid-cols-5 gap-4 overflow-x-auto ">
          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600">Lead ID:</span>
            <span className="text-gray-800">
              {selectedLeadSingle?.lead_id || "N/A"}
            </span>
          </div>
          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600">Lead:</span>
            <span className="text-gray-800">
              {selectedLeadSingle?.lead_primarycontact || "N/A"}
            </span>
          </div>
          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600">Status:</span>
            <button
              className={`cursor-arrow text-sm font-semibold px-2 py-1 rounded-md font-thin ${
                selectedLeadSingle?.lead_status === "newLead"
                  ? "bg-orange-400 text-white"
                  : selectedLeadSingle?.lead_status === "contacted"
                    ? "bg-blue-600 text-white"
                    : selectedLeadSingle?.lead_status === "attemptedToContact"
                      ? "bg-red-400 text-white"
                      : selectedLeadSingle?.lead_status === "qualified"
                        ? "bg-green-400 text-white"
                        : selectedLeadSingle?.lead_status === "unQualified"
                          ? "bg-red-600 text-white"
                          : "bg-gray-200 text-gray-800"
              }`}
            >
              {selectedLeadSingle?.lead_status
                ? selectedLeadSingle.lead_status
                    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
                    .charAt(0)
                    .toUpperCase() +
                  selectedLeadSingle.lead_status
                    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
                    .slice(1)
                : "N/A"}
            </button>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="text-sm font-medium text-gray-700 tracking-wide">
              SalesPerson
            </span>
            <span className="text-md font-normal text-gray-900 truncate max-w-[60%]">
              {selectedLeadSingle?.lead_salespersonName
                ? arrangeSalesPersonNameArray(
                    splitText(selectedLeadSingle.lead_salespersonName),
                  )
                  ? arrangeSalesPersonNameArray(
                      splitText(selectedLeadSingle.lead_salespersonName),
                    )[0][0]
                  : "--"
                : "--"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="text-sm font-medium text-gray-700 tracking-wide">
              Organization
            </span>
            <span className="text-md font-normal text-gray-900 truncate max-w-[60%]">
              {selectedLeadSingle?.lead_organization || (
                <span className="italic text-gray-400">Not specified</span>
              )}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600">Title:</span>
            <span className="text-gray-800">
              {selectedLeadSingle?.lead_primarycontacttitle || "N/A"}
            </span>
          </div>
          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600">Email:</span>
            <span className="text-gray-800">
              {selectedLeadSingle?.lead_email || "N/A"}
            </span>
          </div>
          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600">Phone:</span>
            <span className="text-gray-800">
              {selectedLeadSingle?.lead_phone || "N/A"}
            </span>
          </div>
          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              isPhoneWhatsApp:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_isphonewhatsapp || "N/A"}
            </span>
          </div>
          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              alternatePhone:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_alt_phone || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              isAlternateWhatsApp:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_alt_isphonewhatsapp || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              Lead Source:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_source || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              Coordinator:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_coordinator || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              assignTo:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_assignedto || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">docs:</span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.docs || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              campaignId:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_CampaignId || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              departmentNo:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.departmentNo || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              probability:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_probability || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              bookedAmount:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_bookedamount || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              territory:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_territory || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              country:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_country || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              {/* streetAddress: */}
              street:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_streetaddress || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">city:</span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_city || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              apartment:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_appartment || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              location:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_location || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">area:</span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_area || "N/A"}
            </span>
          </div>

          <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
            <span className="font-medium text-gray-600 block mb-1">
              priority:
            </span>
            <span className="text-gray-800 ">
              {selectedLeadSingle?.lead_priority || "N/A"}
            </span>
          </div>

          <div className="">
            <span className="font-medium text-gray-600 block mb-1">Notes:</span>
            <p className="text-gray-800 bg-gray-50 rounded-lg p-3 border border-gray-200 ">
              {selectedLeadSingle?.lead_notes ||
                "No additional notes available."}
            </p>
          </div>

          {selectedLeadSingle?.Cnt > 0 && (
            <div className="flex justify-between items-baseline py-2 px-4 w-full hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200 last:border-b-0 rounded-lg">
              <span className="font-medium text-gray-600 block mb-1">
                Product:
              </span>
              <span className="text-gray-800 ">Yes</span>
            </div>
          )}
        </div>

        <ProductsInViewLead
          // lead={formData.lead}
          productEntryInAllEntries={productEntryInAllEntries}
          clearProductsList={clearProductsList}
          productEntries={productEntries}
          productsInQuotationState={productsInQuotationState}
          setProductEntries={setProductEntries}
          handleAddRow={handleAddRow}
          handleDeleteSelected={handleDeleteSelected}
          handleInputChange={handleInputChange}
          selectProduct={selectProduct}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          currentProductEntryRowId={currentProductEntryRowId}
          productData={productData}
        />

        {!productsInQuotationState || productsInQuotationState.length === 0 ? (
          <p>No products added.</p>
        ) : null}

        {/* Footer */}
      </div>
    </div>
  );
};

export default ViewLead;
